<template>
  <div>
    <!-- 营业执照 -->
    <img style="width: 100%" src="https://cdn.mekoom.com/assets-v3/certificate/营业执照.jpg" alt="">
  </div>
</template>
<script>
  export default {};
</script>
<style scoped>

</style>
